import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function SearchItems({ product, closeMobileMenu, setSearch }) {
  const { i18n } = useTranslation();
  return (
    <Link
      to={`/product/${product.id}`}
      onClick={() => {
        if (closeMobileMenu) closeMobileMenu();
        if (setSearch) setSearch("");
      }}
      className="d-flex py-2 align-items-start gap-2 border-bottom"
    >
      <img
        src={`${import.meta.env.VITE_REACT_APP_API_URL}/${product.img}`}
        alt="product-image"
        className="rounded-1 object-fit-cover"
        width={"75px"}
        height={"75px"}
        loading="lazy"
      />
      <div className="d-flex flex-column">
        <span className="mb-0 fw-semibold">
          {i18n?.language === "ar" ? product.name : product.name_en}
        </span>
        <span className="text-black fw-medium">
          {" "}
          {product.price}{" "}
          {i18n?.language == "ar"
            ? import.meta.env.VITE_REACT_APP_CURRENCY
            : import.meta.env.VITE_REACT_APP_CURRENCY_EN}
        </span>
      </div>
    </Link>
  );
}
